
import logoDeoapp from '../Assets/Logo/64174d501639e03e287e2160.png'
const themeConfig = {
  logo: logoDeoapp,
  layout: {
    type: "vertical", // vertical, horizontal, vertical-horizontal, blank
    navbar: "",
    sidebar: "",
    footer: "",
    userProfile: "sidebar", // sidebar, navbar **choose when using vertical-horizontal type**
  },
  contentWidth: "full", // full, boxed
};

export default themeConfig;
